'use client';

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/utils/api';
import { useAuthStore } from '@/stores/auth-store';

export interface RegistryAnomalyItem {
	kind: string;
	livello: 'errore' | 'avviso';
	/** Il POD o l'impianto interessato. */
	oggetto: string;
	messaggio: string;
}

const EMPTY: RegistryAnomalyItem[] = [];

/**
 * Anomalie anagrafiche di POD e impianti (`GET /api/anomalies/anagrafica`,
 * INB-349). Calcolate a ogni lettura dall'anagrafica: spariscono quando la si
 * corregge, non si chiudono a mano.
 */
export function useRegistryAnomalies(orgId: string | null | undefined) {
	const loaded = useAuthStore((s) => s.loaded);
	const { data, isLoading, error } = useQuery({
		queryKey: ['registry-anomalies', orgId],
		enabled: loaded && !!orgId,
		queryFn: () =>
			api.get<RegistryAnomalyItem[]>('/api/anomalies/anagrafica', { orgId: orgId as string }),
	});
	return {
		anomalies: data ?? EMPTY,
		isLoading: !!orgId && isLoading,
		error: error ? (error instanceof Error ? error.message : String(error)) : null,
	};
}
